export default "__VITE_ASSET__DfOBtyWz__"